let instance = null;

class GridService {
    constructor(id, gridApi) {
        if (!instance) {
            instance = this;
            instance.gridMap = {};
        }
        if (id && gridApi) {
            instance.gridMap[id] = {
                gridApi,
            };
        }
        return instance;
    }

    gridApi(id) {
        return this.gridMap[id] ? this.gridMap[id].gridApi : null;
    }

    destroy(id) {
        if (this.gridMap[id]) {
            this.gridMap[id].gridApi.destroy();
            delete this.gridMap[id];
        }
    }
}

export default GridService;
